export const sidebarStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  width: 200,
  flexShrink: 0,
  overflowY: 'auto',
  paddingRight: '8px',
  borderRight: ({ palette }) => `1px solid ${palette.divider}`,
};

export const getSidebarItemStyles = isActive => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '8px',
  padding: '6px 8px',
  borderRadius: '6px',
  cursor: 'pointer',
  backgroundColor: ({ palette }) => (isActive ? palette.action.selected : 'transparent'),

  '&:hover': {
    backgroundColor: ({ palette }) => palette.action.hover,
  },
});

export const sidebarItemLabelStyles = {
  color: 'text.primary',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const sidebarItemCountStyles = {
  color: 'text.secondary',
  flexShrink: 0,
};
